var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20801 5.41602C10.1055 5.41602 10.833 4.68848 10.833 3.79102C10.833 2.89355 10.1055 2.16602 9.20801 2.16602C8.31055 2.16602 7.58301 2.89355 7.58301 3.79102C7.58301 4.68848 8.31055 5.41602 9.20801 5.41602Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7915 10.832C4.68897 10.832 5.4165 10.1045 5.4165 9.20703C5.4165 8.30957 4.68897 7.58203 3.7915 7.58203C2.89404 7.58203 2.1665 8.30957 2.1665 9.20703C2.1665 10.1045 2.89404 10.832 3.7915 10.832Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58317 7.58268H10.8332V10.291C10.8332 10.4347 10.7761 10.5725 10.6745 10.674C10.5729 10.7756 10.4352 10.8327 10.2915 10.8327H8.12484C7.98118 10.8327 7.8434 10.7756 7.74182 10.674C7.64024 10.5725 7.58317 10.4347 7.58317 10.291V7.58268ZM2.1665 2.16602H5.4165V4.87435C5.4165 5.01801 5.35944 5.15578 5.25785 5.25737C5.15627 5.35895 5.0185 5.41602 4.87484 5.41602H2.70817C2.56451 5.41602 2.42674 5.35895 2.32515 5.25737C2.22357 5.15578 2.1665 5.01801 2.1665 4.87435V2.16602Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrayIcon);
export default __webpack_public_path__ + "static/media/Tray_Icon.8fc609dfd5e603cea236eb74a8cc4d69.svg";
export { ForwardRef as ReactComponent };